function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0197 19.7086L13.422 19.7086L16.4834 25.6925L22.0197 19.7086Z",
  fill: "#FFCB7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19253 11.1451L4.93034 13.8829C6.41379 15.3664 8.54004 16.0111 10.5976 15.6013V15.6013C11.2834 15.4647 11.9921 15.6796 12.4866 16.1741L12.547 16.2345C13.0415 16.729 13.2564 17.4377 13.1198 18.1235V18.1235C12.71 20.1811 13.3547 22.3073 14.8382 23.7908L17.576 26.5286",
  stroke: "white",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2028 2.13552L13.9406 4.87333C15.4241 6.35678 16.0688 8.48303 15.659 10.5405V10.5405C15.5224 11.2264 15.7373 11.9351 16.2318 12.4296L16.2921 12.49C16.7866 12.9844 17.4954 13.1993 18.1812 13.0628V13.0628C20.2387 12.653 22.365 13.2977 23.8484 14.7812L26.5862 17.519",
  stroke: "white",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1819 1.4751L1.75418 12.9028",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4636 15.7621L16.0359 27.1898",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 29,
  fill: "white"
})));

var SvgColorHourglass = function SvgColorHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color-hourglass.45f909a1.svg";
export { ForwardRef as ReactComponent };